import { useAuthStore } from '@/store/auth'
import { useRouteStore } from '@/store/route'
import { useEffect, useRef } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

export const ProtectedRoute = () => {
  const hasHydrated = useAuthStore((state) => state._hasHydrated)
  const authToken = useAuthStore((state) => state.authToken)
  const user = useAuthStore((state) => state.user)
  const fetchCharity = useRouteStore((state) => state.fetchCharity)
  const fetchVehicles = useRouteStore((state) => state.fetchVehicles)

  const isAuthenticated = !!authToken
  const hasFetchedRef = useRef(false)

  useEffect(() => {
    if (
      !hasHydrated ||
      !user?.charity_id ||
      !user?.email ||
      hasFetchedRef.current
    )
      return
    hasFetchedRef.current = true
    fetchCharity(user.charity_id)
    fetchVehicles(user.charity_id, user.email)
  }, [hasHydrated, user?.charity_id, user?.email, fetchCharity, fetchVehicles])

  // Wait for hydration before making auth decisions
  if (!hasHydrated) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
